export function inheritsCSSclass(element, className) {
  while (element?.classList) {
    if (element.classList.contains(className)) return true;
    element = element.parentElement;
  }
  return false;
}

export function downloadPlaintext(plaintext, filename) {
  const blob = new Blob([plaintext], { type: 'text/plain' });
  const link = document.createElement('a');
  link.download = filename + ".txt";
  link.href = window.URL.createObjectURL(blob);
  link.click();
}
